import React from 'react';
import { motion } from 'framer-motion';
const points = ['Noches en vela buscando actividades que nunca terminan de encajar con lo que necesitas enseñar', 'Clases improvisadas porque no encontraste material listo a tiempo', 'Alumnos desconectados que no entienden para qué sirve estudiar historia', 'Silencios incómodos frente a preguntas complejas sobre procesos históricos', 'Fines de semana perdidos armando evaluaciones y secuencias desde cero'];
export function PainPoints() {
  return <section className="bg-black px-4 py-20" data-id="element-115">
      <div className="mx-auto max-w-3xl" data-id="element-116">
        <motion.header initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12 text-center" data-id="element-117">
          <h2 className="font-serif text-3xl font-bold sm:text-4xl" data-id="element-118">
            ¿Te suena conocido esto?
          </h2>
          <p className="mt-6 rounded-2xl border border-dark-border bg-dark-card p-6 text-left leading-relaxed text-gray-300" data-id="element-119">
            Domingo a las 11 de la noche. Mañana tienes clase de historia. Y
            todavía estás buscando cómo explicar la diferencia entre los
            procesos independentistas o cómo armar una actividad sobre la Guerra
            Fría que realmente funcione en el aula.
            <br data-id="element-120" />
            <br data-id="element-121" />
            <strong className="text-gold-light" data-id="element-122">No es tu culpa.</strong> Llevas
            años peleando con libros de texto rígidos, contenido disperso en
            internet y materiales que después tienes que reescribir enteros para
            que se adapten a tu nivel y a tu programa.
          </p>
        </motion.header>

        <h3 className="mb-6 text-center text-lg font-bold" data-id="element-123">
          El costo de no tener el material correcto:
        </h3>

        <ul className="space-y-3" data-id="element-124">
          {points.map((point, i) => <motion.li initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} key={point} className="flex gap-4 rounded-xl border border-red-900/30 bg-dark-card p-4 text-sm leading-relaxed text-gray-300" data-id="element-125">
              <span className="text-red-500" data-id="element-126">●</span>
              {point}
            </motion.li>)}
        </ul>

        <div className="mt-12 border-t border-dark-border pt-8 text-center" data-id="element-127">
          <p className="font-serif text-2xl font-bold text-gold-gradient" data-id="element-128">
            Basta de regalar tu tiempo libre.
          </p>
          <p className="mt-3 text-lg" data-id="element-129">
            Resuelve tu año entero de clases de Historia en solo 5 MINUTOS.
          </p>
        </div>
      </div>
    </section>;
}